import request from '@/utils/request'
// 综合柜详情


// 根据筛选条件查询综合柜的列表信息
export function getCabinetBeanById(data) {
    return request({
        url: 'device-service/cabinetDetails/getCabinetBeanById',
        method: 'get',
        params: data
    })
}

// 根据cabinetCode查询综合柜的柜内设备类型
export function getCabinetTypesByCode(data) {
    return request({
        url: 'device-service/cabinetDetails/getCabinetTypesByCode',
        method: 'get',
        params: data
    })
}

// 根据deviceCode查询综合柜内设备的基本信息
export function getInsideDeviceByCode(data) {
    return request({
        url: 'device-service/inside/getInsideDeviceByCode',
        method: 'get',
        params: data
    })
}

// 根据deviceCode查询综合柜中设备的简略数据
export function getDeviceParamByCode(data) {
    return request({
        url: 'snmp-service/param/getDeviceParamByCode',
        method: 'get',
        params: data
    })
}

// 根据deviceCode查询综合柜中设备的详细数据
export function getDeviceDetailByCode(data) {
    return request({
        url: 'snmp-service/param/getDeviceDetailByCode',
        method: 'get',
        params: data
    })
}

// 根据deviceCode更新综合柜中设备的数据
export function updateDeviceParamByCode(data) {
    return request({
        url: 'snmp-service/param/updateDeviceParamByCode',
        method: 'get',
        params: data
    })
}

// 根据deviceCode查询综合柜中设备的遥调遥控数据
export function getDeviceRemoteParamByCode(data) {
    return request({
        url: 'snmp-service/param/getDeviceRemoteParamByCode',
        method: 'get',
        params: data
    })
}

// 发送设备写操作
export function sendDeviceParam(data) {
    return request({
        url: 'snmp-service/param/sendDeviceParam',
        method: 'post',
        data
    })
}


// 获取历史轨迹
export function getTaskTrajectoryList(data) {
    return request({
        url: "trajectory-service/trajectory/getTaskTrajectoryList",
        method: "get",
        params: data,
    });
}


// 获取萤石Token
export function getShiYingToken() {
    return request({
        url: 'camera-service/token/getShiYingToken',
        method: 'get',
    })
}

// 获取萤石播放地址
export function getShiYingVideoPath(params) {
    return request({
        url: 'camera-service/token/getShiYingVideoPath',
        method: 'get',
        params
    })
}

// 获取抓拍记录
export function getMonitorList(params) {
    return request({
        url: 'device-service/monitor/getMonitorList',
        method: 'get',
        params
    })
}
